import { Component, h, Host, Prop } from "@stencil/core";
import { ZapierLogoIcon } from "../../lib/icons";
import { zapierURL } from "../../api/config";

@Component({
  tag: "zapier-intro-copy",
  styleUrl: "zapier-intro-copy.css",
  shadow: true,
})
export class ZapierIntroCopy {
  /** The title of the app */
  @Prop() appTitle = "this";

  render() {
    return (
      <Host>
        <h2>
          <a href={zapierURL} target="_blank">
            <ZapierLogoIcon />
          </a>
        </h2>
        <p>
          Zapier connects {this.appTitle} to thousands of apps. Start automating
          and save time.
        </p>
      </Host>
    );
  }
}
